import { z } from 'zod';

export const CandidateProfileSchema = z.object({
  communicationAlertsConfigured: z.boolean(),
  communicationAlertsTextMessagesEnabled: z.boolean(),
});

export type CandidateProfile = z.infer<typeof CandidateProfileSchema>;
